<div class="dialogContainer">
  <div class="header">
    <h2>Copy Lines</h2>
  </div>
  <div class="content">
    <div class="tableContainer">
      <entity-search [entityName]="entityName" [statusFilter]="'PR'" (entitySelected)="setSelected($event)"
      (newEntityRequested)="newQuote()"></entity-search>
    </div>
    @if (errorMessage()) {
      <div class="errorMessage">
        {{ errorMessage() }}
      </div>
    }
  </div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
      <button class="warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
      <button class="primary-button" [disabled]="!selectedQuote" matButton="elevated" (click)="saveAndClose()">Save</button>
    </span>
  </div>
</div>
